// extracted by mini-css-extract-plugin
module.exports = {"container":"benefits_container__vm_xU","list":"benefits_list__1eqCD"};